import http from '@libs/services/http'
import {
  HousingMarketSearchQuery,
  ComparableMarketResponse
} from '@libs/types/generated/housing-market-ui'
import {
  RateAggregate,
  SearchRateStatsPayload
} from '@libs/types/generated/rate-stats-api'
import { Cadence, SortByOption } from '../types/rate-state.d'

const apiUrl = process.env.NEXT_PUBLIC_HOUSING_MARKET_API_URL
const marketServiceUrl = process.env.MARKETS_SERVICE_URL
const rateStateApieUrl = process.env.RATE_STATS_API_URI

export async function fetchHousingMarket(
  query: Partial<HousingMarketSearchQuery>
) {
  const url = `${apiUrl}/housing-market`
  const { data } = await http.get(url, { params: query })
  return data
}

export async function fetchComparableMarkets(
  query: Partial<HousingMarketSearchQuery>
): Promise<ComparableMarketResponse[]> {
  const url = `${apiUrl}/housing-market/comparable-markets`
  const { data } = await http.get(url, { params: query })
  return data
}

/*
parameters: state and city (option)
retunrs: geo maket id
 */
export async function fetchGeoMarkets(
  query: Partial<HousingMarketSearchQuery>
): Promise<number | null> {
  const queriedState = query.state
  const queriedCity = query.city || ''

  let payload = {}

  if (queriedCity) {
    payload = {
      query: {
        state: [queriedState],
        city: [queriedCity]
      },
      disable_cache: query.disable_cache || false
    }
  } else {
    payload = {
      query: {
        state: [queriedState]
      },
      disable_cache: query.disable_cache || false
    }
  }

  const url = `${marketServiceUrl}/search`

  try {
    const { data } = await http.post(url, payload)

    return data.results[0].id //market id
  } catch (error) {
    console.log(error)
    return null
  }
}

export async function fetchMortgageRateState(
  criteria: SearchRateStatsPayload
): Promise<RateAggregate[]> {
  const { query, disable_cache } = criteria
  const market_ids = query?.market_ids as number[] | []
  const product_ids = query?.product_ids as number[] | [1]
  const date_start = query?.date_from as Date | undefined
  const date_end = query?.date_to as Date | undefined
  const cadence = query?.cadence as Cadence | undefined
  const sort_by = query?.sort_by as SortByOption | undefined
  const date_from = date_start?.toISOString().split('T')[0] || '' //format to: YYYY-MM-DD
  const date_to = date_end?.toISOString().split('T')[0] || '' //format to: YYYY-MM-DD

  const payload = {
    query: {
      market_ids,
      product_ids,
      cadence,
      date_from,
      date_to,
      sort_by
    },
    disable_cache: disable_cache || false
  }

  const url = `${rateStateApieUrl}/stats`
  try {
    const { data } = await http.post(url, payload)

    return data.results
  } catch (error) {
    console.log(error)
    return []
  }
}
